<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="product-detail">
    <s-header :name="'商品详情'"></s-header>
    <div class="detail-content">
      <div class="detail-swipe-wrap">
        <van-swipe class="my-swipe" indicator-color="#1baeae">
          <van-swipe-item
            v-for="(item, index) in detail.goodsCarouselList"
            :key="index"
          >
            <img :src="item" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="product-info">
        <div class="product-title">
          {{ detail.goodsName || '' }}
        </div>
        <div class="product-desc"></div>
        <div class="product-price">
          <span>¥{{ detail.sellingPrice || '' }}</span>
          <!-- <span>库存203</span> -->
        </div>
        <p>签约方选择:</p>
        <div class="product-list">
          <ul>
            <li
              :class="goodsSkuId == data.goodsSkuId ? 'radioon' : 'radiooff'"
              v-for="data in detail.goodsSkuList"
              :key="data.goodid"
              :name="data.goodsSkuId"
              @click="goodsSkuIdClick(data)"
            >
              {{ data.collection }}
            </li>
          </ul>
        </div>
        <!-- <van-radio-group v-model="goodsSkuId" direction="horizontal">
          <van-radio class="activebg" v-for="data in detail.goodsSkuList"
            :key="data.goodid"
            :name="data.goodsSkuId">
            
            <template #icon="props">
              <img
                class="img-icon"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
          </van-radio>
        </van-radio-group> -->
      </div>
      <div class="product-intro">
        <!-- <ul>
          <li>
            原价：<span>¥{{ detail.originalPrice }}</span>
          </li>
          <li>数量：<span>-</span>（吨/年）</li>
          <li>合作商家：<span>-</span></li>
        </ul> -->
        <div
          v-if="detail.goodAddress || detail.callFirst || detail.callSecond"
          class="product-address"
        >
          <div><h3>商家地址</h3></div>
          <div class="product-tel" v-if="detail.goodAddress">
            <div><van-icon name="map-marked" /> {{ detail.goodAddress }}</div>
            <van-icon
              v-if="detail.latitude"
              style="color: #64b8e7"
              name="location"
              @click="wxMpa"
            />
          </div>
          <div class="product-tel" v-if="detail.callFirst">
            <div><van-icon name="graphic" /> {{ detail.callFirst }}</div>
            <a :href="'tel:' + detail.callFirst">
              <van-icon style="color: #64b8e7" name="phone"
            /></a>
          </div>
          <div class="product-tel" v-if="detail.callSecond">
            <div><van-icon name="graphic" /> {{ detail.callSecond }}</div>
            <a :href="'tel:' + detail.callSecond">
              <van-icon style="color: #64b8e7" name="phone"
            /></a>
          </div>
        </div>
        <div id="map"></div>

        <div
          class="product-content"
          v-html="detail.goodsDetailContent || ''"
        ></div>
      </div>
    </div>
    <van-action-bar>
      <van-action-bar-icon
        icon="cart-o"
        :badge="!count ? '' : count"
        @click="goTo()"
        text="购物车"
      />
      <van-action-bar-button
        v-if="goodsContract"
        type="warning"
        @click="goContract(goodsContract)"
        text="查看合同"
      />
      <van-action-bar-button type="danger" @click="goToCart" text="支付" />
    </van-action-bar>
    <van-dialog v-model:show="show" title="合同选择">
      <a
        :href="contract[item][0]"
        target="_blank"
        v-for="(item, index) in contractArr"
        :key="index"
        class="urlPdf"
        >{{ contract[item][1] }}</a
      >
    </van-dialog>
  </div>
</template>

<script>
import { reactive, onMounted, computed, toRefs, nextTick, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getDetail } from '@/service/good'
import { addCart, getWx } from '@/service/cart'
import sHeader from '@/components/SimpleHeader'
import { Dialog } from 'vant'
import { prefix } from '@/common/js/utils'
import { Toast } from 'vant'

export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const state = reactive({
      wxdata: {},
      goodsContract:null,
      detail: {
        goodsCarouselList: []
      },
      goodsSkuId: null
    })
    const show = ref(false)
    const url = reactive({
      contract: {
        HPHW08: [
          'https://mall-api.oiltour.cn/090114041721.html',
          '黄埔首联-废机油'
        ],
        ZQHW08: [
          'https://mall-api.oiltour.cn/090114181150.html',
          '肇庆科能-废机油'
        ],
        KRHW08: [
          'https://mall-api.oiltour.cn/090114301741.html',
          '深圳开瑞-废机油'
        ],
        HW18: ['https://mall-api.oiltour.cn/090114333050.html', '焚烧合同'],
        HW199: ['https://mall-api.oiltour.cn/090114333050.html', '焚烧合同']
      },
      contractArr: []
    })

    onMounted(async () => {
      const obj = {
        url: document.location.protocol + '//' + document.location.host + '/'
      }
      getWx(obj).then((res) => {
        window.wx.config({
          debug: false,
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: ['checkJsApi', 'openLocation']
        })
      })
      const { id } = route.params
      const { data } = await getDetail(id)
      data.goodsCarouselList = data.goodsCarouselList.map((i) => prefix(i))
      state.detail = data
      store.dispatch('updateCart')
    })

    nextTick(() => {
      // 一些和DOM有关的东西
      const content = document.querySelector('.detail-content')
      content.scrollTop = 0
    })

    const goBack = () => {
      router.go(-1)
    }

    const goTo = () => {
      router.push({ path: '/cart' })
    }
    const goContract = (url) => {
      // let wasteData = state.detail.wasteType.split(',')
      // var ua = navigator.userAgent.toLowerCase()
      // if (state.detail.collection === '广州黄埔首联环境科技有限公司') {
      //   const index = wasteData.findIndex((item) => item === 'HW08')
      //   wasteData[index] = 'HPHW08'
      // }
      // if (state.detail.collection === '深圳开瑞环保科技有限公司') {
      //   const index = wasteData.findIndex((item) => item === 'HW08')
      //   wasteData[index] = 'KRHW08'
      // }
      // if (state.detail.collection === '肇庆科能环保科技有限公司') {
      //   const index = wasteData.findIndex((item) => item === 'HW08')
      //   wasteData[index] = 'ZQHW08'
      // }
      // if (wasteData.length === 1) {
      //   if (/micromessenger/.test(ua)) {
      //     window.location.href = url.contract[wasteData][0]
      //   } else {
      //     window.location.href = url.contract[wasteData][0]
      //   }
      // }
      console.log(state.detail.goodsCarouselList.contract)
      window.location.href = url
      // if (wasteData.length > 1) {
      //   show.value = true
      //   url.contractArr = []
      //   wasteData.forEach((element) => {
      //     url.contractArr.push(element)
      //   })
      // }
    }

    const goToCart = async () => {
      if (state.goodsSkuId) {
        await addCart({
          goodsCount: 1,
          goodsId: state.detail.goodsId,
          goodsSkuId: state.goodsSkuId
        })
        store.dispatch('updateCart')
        router.push({ path: '/cart' })
      } else {
        Toast.fail('请选择签约方')
      }
    }

    const count = computed(() => {
      return store.state.cartCount
    })
    const goodsSkuIdClick = (data) => {
      state.goodsSkuId = data.goodsSkuId
      state.goodsContract = data.contract
    }
    const wxMpa = () => {
      window.wx.ready(function () {
        window.wx.openLocation({
          longitude: bMapToQQMap(
            Number(state.detail.latitude),
            Number(state.detail.longitude)
          )[0], // 经度，浮点数，范围为180 ~ -180。
          latitude: bMapToQQMap(
            Number(state.detail.latitude),
            Number(state.detail.longitude)
          )[1], // 纬度，浮点数，范围为90 ~ -90
          name: state.detail.locationName, // 位置名
          address: state.detail.goodAddress, // 地址详情说明
          scale: 10, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        })
      })
    }
    //百度经纬度转腾讯经纬度
    const bMapToQQMap = (lng, lat) => {
      let x_pi = (3.14159265358979324 * 3000.0) / 180.0
      let x = lng - 0.0065
      let y = lat - 0.006
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
      let lngs = z * Math.cos(theta)
      let lats = z * Math.sin(theta)
      return [lats, lngs]
    }

    return {
      bMapToQQMap,
      wxMpa,
      ...toRefs(url),
      ...toRefs(state),
      goBack,
      goTo,
      goContract,
      goToCart,
      count,
      show,
      goodsSkuIdClick
    }
  },
  components: {
    sHeader,
    // 引入Van弹出层
    [Dialog.Component.name]: Dialog.Component
  }
}
</script>

<style lang="less">
@import '../common/style/mixin';
.product-list {
  ul li {
    padding: 3px 6px;
    border-radius: 15px;
    display: inline-block;
  }
  .radioon {
    border: 1px solid #40c6ff;
    color: #40c6ff;
  }
  .radiooff {
    border: 1px solid #ebedf0;
    background: #ebedf0;
  }
}
.bm-view {
  width: 100%;
  height: 300px;
}
.product-detail {
  .van-dialog__content {
    text-align: center;
    .urlPdf {
      width: 90%;
      display: inline-block;
      color: rgb(255, 255, 255);
      background: linear-gradient(
        to right,
        rgb(107, 216, 216),
        rgb(27, 174, 174)
      );
      border: 0px;
      border-radius: 3px;
      height: 1.2rem;
      line-height: 1.2rem;
      margin: 10px 0;
    }
  }
  .detail-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .fj();
    .wh(100%, 44px);
    line-height: 44px;
    padding: 0 10px;
    .boxSizing();
    color: #252525;
    background: #fff;
    border-bottom: 1px solid #dcdcdc;
    .product-name {
      font-size: 14px;
    }
  }
  .detail-content {
    height: calc(100vh - 50px);
    overflow: hidden;
    overflow-y: auto;
    .detail-swipe-wrap {
      .my-swipe .van-swipe-item {
        img {
          width: 100%;
        }
      }
    }
    .product-info {
      padding: 0 20px;
      .product-title {
        font-size: 18px;
        text-align: left;
        color: #333;
      }
      .product-desc {
        font-size: 14px;
        text-align: left;
        color: #999;
        padding: 5px 0;
      }
      .product-price {
        .fj();
        span:nth-child(1) {
          color: #f63515;
          font-size: 22px;
        }
        span:nth-child(2) {
          color: #999;
          font-size: 16px;
        }
      }
    }
    .product-intro {
      width: 100%;
      padding-bottom: 50px;
      ul {
        .fj();
        width: 100%;
        margin: 10px 0;
        li {
          flex: 1;
          padding: 5px 0;
          text-align: center;
          font-size: 12px;
          color: #afafaf;
          box-sizing: border-box;
          &:last-child {
            border-right: none;
          }
        }
      }
      .product-content {
        padding: 0 20px;
        img {
          width: 100%;
        }
      }
      .product-address {
        padding: 0 20px;
        h3 {
          margin-bottom: 5px;
        }
        .product-tel {
          display: flex;
          justify-content: space-between;
          font-size: 0.37333rem;
          padding: 15px 0;
          border-bottom: 1px solid #e1e1e1;
          i {
            font-size: 16px;
            position: relative;
            top: 2px;
          }
        }
      }
    }
  }
  .van-action-bar-button--warning {
    background: linear-gradient(to right, #64b8e7, @primary);
  }
  .van-action-bar-button--danger {
    background: linear-gradient(to right, @primary, #64b8e7);
  }
}
</style>
